import { useSelector } from 'react-redux';

import ResourceModal from 'app/components/ResourceModal';
import MomentsUploadForm from './MomentsUploadForm';
import KioskUploadForm from './KioskUploadForm';

const MomentsUploadModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    jobId,
    customerId,
    storyIds,
    jobConfigs
  } = props;

  const account = useSelector(state => state.portalReducer.account);

  let action = 'create';
  let title = 'New Upload';
  let unmountOnClose = true;

  const onSubmit = params => onFormSubmit(action, params);

  let Form = account.feature_flags.kiosk_mode ? KioskUploadForm : MomentsUploadForm;

  return (
    <ResourceModal {...{ isOpen, onClose, title, unmountOnClose }}>
      <Form {...{ action, onClose, onSubmit, jobId, customerId, storyIds, jobConfigs }} />
    </ResourceModal>
  );
}

export default MomentsUploadModal;
